import VueFormulate from "@braid/vue-formulate";
import "swiper/css/swiper.css";
import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import CoolLightBox from "vue-cool-lightbox";
import VueGtag from "vue-gtag";
import VueMeta from "vue-meta";
import VueProgressiveImage from "vue-progressive-image";
import VueScrollTo from "vue-scrollto";
import App from "./App.vue";
import router from "./router";
import { store } from "./store";

Vue.config.productionTip = false;
Vue.use(VueScrollTo);
Vue.use(VueProgressiveImage);
Vue.use(VueAwesomeSwiper /* { default options with global component } */);

Vue.use(VueFormulate);
Vue.use(CoolLightBox);

Vue.use(VueMeta);
Vue.use(VueGtag, {
  config: {
    id: "UA-88020844-36",
    params: {
      send_page_view: false,
    },
  },
});
Vue.filter("priceVndFormat", function(value) {
  if (!value) return "";
  return Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
  }).format(value);
});
new Vue({
  router,
  render: (h) => h(App),
  store,
}).$mount("#app");
